<template>
    <div class="tab-content">
        <view-form v-show="physician.ViewTab" ref="viewForm" :documentOptions="documentOptions"></view-form>
        <upload-new-form
            v-show="physician.UploadTabs"
            :documentOptions="documentOptions"
            @documents-uploaded="refreshDocuments"
        ></upload-new-form>
        <request-form v-show="physician.RequestTab"></request-form>
    </div>
</template>
<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import PhysicianMixin from 'mixins/PhysicianMixin'
    import ViewForm from 'components/forms/view-document/ViewForm'
    import UploadNewForm from 'components/forms/upload-new/UploadNewForm'
    import RequestForm from 'components/forms/request-records/RequestForm'
    import PatientAPI from 'api/PatientAPI'

    export default {
        mixins: [FormMixin, HandleRequestMixin, PhysicianMixin],
        components: {
            ViewForm,
            UploadNewForm,
            RequestForm,
        },
        props: {
            physician: { type: Object, required: true },
        },

        data() {
            return {
                documentOptions: [],
            }
        },

        methods: {
            getDocumentType() {
                PatientAPI.getDocumentType().then((res) => {
                    this.documentOptions = res.map((item) => ({
                        label: item.name,
                        value: item.id,
                    }))
                })
            },
            refreshDocuments() {
                if (this.$refs.viewForm) {
                    this.$refs.viewForm.offset = 0
                    this.$refs.viewForm.documents = []
                    this.$refs.viewForm.getDocuments()
                }
            },
        },
        mounted() {
            this.getDocumentType()
        },
    }
</script>
